import { useStyles } from './FeatureListForBlockPage.styles'

type BlockFeatureItem = {
  feature: string | JSX.Element
  icon?: JSX.Element
}

export const FeatureListForBlockPage = ({
  features,
}: {
  features: BlockFeatureItem[]
}) => {
  const { classes } = useStyles()
  return (
    <>
      {features?.map((featureItem, index) => {
        return (
          <div className={classes.listItem} data-testid={'feature-item'}>
            {featureItem?.icon ? featureItem?.icon : <></>}
            <li key={index} className={classes.listItemText}>
              {featureItem?.feature}
            </li>
          </div>
        )
      })}
    </>
  )
}
